import React, { Component } from "react";

import {Dropdown, Tabs} from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

class MyHeader extends Component {
  constructor(props) {
    super(props);
    this.newTabIndex = 0;

    this.state = {
      panes: this.props.panes,
      activeKey: this.props.panes[0].key,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ panes: props.panes, activeKey: props.activeKey });
  }

  onChange = (activeKey) => {
    this.setState({ activeKey });
    this.props.syncState(this.state.panes, activeKey);
  };

  onEdit = (targetKey, action) => {
    this[action](targetKey);
  };

  remove = (targetKey) => {
    let activeKey = this.state.activeKey;
    let lastIndex;

    this.state.panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        lastIndex = i - 1;
      }
    });
    const panes = this.state.panes.filter((pane) => pane.key !== targetKey);
    if (panes.length && activeKey === targetKey) {
      if (lastIndex >= 0) {
        activeKey = panes[lastIndex].key;
      } else {
        activeKey = panes[0].key;
      }
    }

    this.setState({ panes, activeKey });
    this.props.syncState(panes, activeKey);
  };

  // Ferme tous les onglets sauf Accueil (permanent), qui redevient actif
  handleCloseTabs = () => {
    const panes = this.state.panes.filter((pane) => pane.key === "1");

    this.setState({ panes, activeKey: "1" });
    this.props.syncState(panes, "1");
  };

  add = () =>
    this.props.addPanesRequete(
      { key: "26", title: "Contrats / Disponibilités", content: "" },
      "26",
      null
    );

  render() {
    const { panes, activeKey } = this.state;

    const dropdownItems = [
      {
        key: "1",
        label: "Fermer tous les onglets",
        icon: <CloseCircleOutlined />,
        onClick: () => this.handleCloseTabs(),
      },
    ];

    const items = panes.map((pane) => {
      return {
        label: pane.title,
        key: pane.key,
        closable: pane.key !== "1", // Accueil : onglet permanent
        // Pas de children : la barre n'affiche que les onglets, le contenu est rendu par Router
      };
    });

    return (
      // <Header style={{ background: "#000", padding: 0, height: '100%' }}>
      // padding haut : remplace le padding haut de Layout.Content (Router) ; fond = Layout.bodyBg antd, masque le contenu qui défile dessous
      <div style={{ padding: "15px 0 0", position: "sticky", top: 0, zIndex: 10, background: "#f5f5f5" }}>
        <Dropdown menu={{ items: dropdownItems }} trigger={["contextMenu"]}>
          <Tabs
            type="editable-card"
            className="tabs-panel-haut"
            activeKey={activeKey}
            onChange={this.onChange}
            onEdit={this.onEdit}
            items={items}
          ></Tabs>
        </Dropdown>
      </div>
      // </Header>
    );
  }
}

export default MyHeader;
